import axios from "axios";
import { getAuthorizationToken } from "../config/user";
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

function sendComment(data) {
  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/add-doc-comment`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function getDocumentComments(commentOn, documentId) {
  return axios({
    methos: "get",
    url: `${REACT_APP_API_URL}/doc-comments?commentOn=${commentOn}&documentId=${documentId}`,
    headers: getAuthorizationToken(),
  });
}
function getAllUserDetail() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/all-user-detail`,

    headers: getAuthorizationToken(),
  });
}
function getDefaultRisks() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/defult-risks`,
    headers: getAuthorizationToken(),
  });
}

function getCaseTypeProcedureMapping() {
  return axios({
    method: "get",
    url: `${REACT_APP_API_URL}/get-casetype-procedure-mapping`,
    headers: getAuthorizationToken(),
  });
}

function updateViewDetail(data) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/view-doc-comment`,
    data: data,
    headers: getAuthorizationToken(),
  });
}
function markNotificationReadByDocId(docId) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/read-notification-by-docid?documentId=${docId}`,
    headers: getAuthorizationToken(),
  });
}
function readDocCommentNotification(docId) {
  return axios({
    method: "put",
    url: `${REACT_APP_API_URL}/read-cc-doc-comment-notification?documentId=${docId}&currDate=${new Date().toISOString()}`,
    headers: getAuthorizationToken(),
  });
}

export const CommentServices = {
  sendComment,
  getAllUserDetail,
  getDocumentComments,
  updateViewDetail,
  markNotificationReadByDocId,
  getDefaultRisks,
  readDocCommentNotification,
  getCaseTypeProcedureMapping,
};
